/**
 * Hard navigation to pick up a new deploy's index.html + chunk hashes.
 * Soft reload() often reuses a cached shell after frequent deploys.
 */
export function forceAppUpdate(): void {
  try {
    sessionStorage.removeItem("chunk-reload-attempted");
    sessionStorage.removeItem("app-build-id");
  } catch {
    /* ignore */
  }
  const url = new URL(window.location.href);
  url.searchParams.set("_refresh", String(Date.now()));
  window.location.replace(url.toString());
}

export function isStaleChunkErrorMessage(message: string | undefined | null): boolean {
  if (!message) return false;
  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading chunk \d+ failed/i.test(
    message
  );
}
